if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));
    
     // Select all links with hashes
    $('a[href*="#"]:not(.fancybox)')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
    // On-page links
    if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
    ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
            scrollTop: target.offset().top
        }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
            return false;
            } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
            };
        });
        }
    }
    });   
    //opentable toggle
    $('.opentable-toggle').on('click', function(e){
        e.preventDefault();
        $('.toggle-container').fadeToggle(500);
        $(this).toggleClass('close');
    });

    $('.sym-slides').slick({
        accessibility: false
    });
    var imgs = $('.slider img');
    imgs.each(function(){
    var item = $(this).closest('.item');
    item.css({
        'background-image': 'url(' + $(this).attr('src') + ')', 
        'background-position': 'center',            
        '-webkit-background-size': 'cover',
        'background-size': 'cover', 
    });
    $(this).hide();
    });

    $("a.video-clip").fancybox({ 
      
    });


    //Function to modify menus-nav sub-menu aria-label
    document.addEventListener('DOMContentLoaded', function(){
        const headerSubMenu = document.querySelector('.menus-navi nav.sub-menu'); 
        if(headerSubMenu){
            headerSubMenu.setAttribute('aria-label','Menus Navigation')
        }
    });


})();